import { EMPTY_VALUE } from '@/constants/app.constants';
import { PCMP_CHANNEL_LABELS, PCMP_LANE_TONE_COLOR } from '../../constants/pcmpProposal.constants';
import type { PcmpLaneCell, PcmpStatusView } from '../../types/pcmpProposal.types';
import { PcmpStatusPill } from './PcmpStatusPill';

interface PcmpLaneStatusStripProps {
  status: PcmpStatusView;
}

const LANES = [
  { key: 'marketing', label: 'Marketing' },
  { key: 'mis', label: 'MIS' },
  { key: 'accounts', label: 'Accounts' },
  { key: 'overall', label: 'Overall' },
] as const satisfies readonly { key: keyof PcmpStatusView['lanes']; label: string }[];

function renderCell(cell: PcmpLaneCell) {
  if (!cell.text) return <span className="text-sm text-muted-foreground">{EMPTY_VALUE}</span>;
  return (
    <div className="flex flex-col gap-1">
      <PcmpStatusPill tone={PCMP_LANE_TONE_COLOR[cell.tone]}>{cell.text}</PcmpStatusPill>
      {cell.sub ? <span className="text-xs text-muted-foreground">{cell.sub}</span> : null}
    </div>
  );
}

/** The four lane cells (legacy _StatusLaneCells) plus the routed channel. */
export function PcmpLaneStatusStrip({ status }: PcmpLaneStatusStripProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-5">
      {LANES.map((lane) => (
        <div key={lane.key} className="flex flex-col gap-1.5">
          <p className="text-xs text-muted-foreground">{lane.label}</p>
          {renderCell(status.lanes[lane.key])}
        </div>
      ))}
      <div className="flex flex-col gap-1.5">
        <p className="text-xs text-muted-foreground">Channel</p>
        <span className="text-sm font-medium">
          {status.channel ? PCMP_CHANNEL_LABELS[status.channel] : 'Not routed'}
        </span>
      </div>
    </div>
  );
}
